import * as R from 'ramda';

const update = store => async (state, { id, ...opt }) => {
    const userClientId = state.user.selectedUserClientId;

    const newById = R.mergeLeft(
        opt,
        R.path(
            ['clients', userClientId, 'reports', 'byId', id],
            store.getState(),
        ),
    );

    store.setState(
        R.assocPath(
            ['clients', userClientId, 'reports', 'byId', id],
            newById,
            store.getState(),
        ),
        true,
    );
};

export default update;
